import { tv } from "tailwind-variants";

import { Button } from "./button";
import type { IconType } from "./icons";

const inputRightButtonVariants = tv({
  base: "size-4",
  variants: {
    hasError: {
      true: "text-danger",
      false: "text-content-muted",
    },
  },
});

export const InputRightButton = (hasError: boolean, onClick: () => void, Icon: IconType) => {
  return (
    <Button aria-label="Clear" onClick={onClick} size="tight" variant="focus">
      <Icon className={inputRightButtonVariants({ hasError })} />
    </Button>
  );
};
